export type POIModelPoiType = (typeof POIModelPoiType)[keyof typeof POIModelPoiType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const POIModelPoiType = {
    PlanarFace: 'PlanarFace',
    StraightWall: 'StraightWall'
} as const;
